import type { InjectionKey } from "vue";
import type { Router } from "vue-router";

export const ROUTER_SERVICE_INJECTION_KEY: InjectionKey<Router> =
  Symbol("ROUTER_SERVICE");
